import React from "react";

// Logo ufficiale Venergia: versione colorata su sfondo chiaro, bianca su sfondo scuro.
export const VenergiaLogo = ({ className = "h-8" }) => (
  <span className="inline-flex" data-testid="venergia-logo">
    <img src="/brands/venergia-sito.png" alt="Venergia" className={`${className} w-auto dark:hidden`} />
    <img src="/brands/venergia-scuro.png" alt="Venergia" className={`${className} w-auto hidden dark:block`} />
  </span>
);
